import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "assigneeType",
    "userBlock",
    "contactBlock",
    "completionTasks",
    "completionTaskTemplate"
  ]

  toggleAssignee() {
    const value = this.assigneeTypeTarget.value
    const userSelect = this.userBlockTarget.querySelector("select")
    const contactSelect = this.contactBlockTarget.querySelector("select")

    this.userBlockTarget.style.display = "none"
    this.contactBlockTarget.style.display = "none"
    userSelect.disabled = true
    contactSelect.disabled = true

    if (value === "User") {
      this.userBlockTarget.style.display = ""
      userSelect.disabled = false
    } else if (value === "Contact") {
      this.contactBlockTarget.style.display = ""
      contactSelect.disabled = false
    }
  }

  addCompletionRow(event) {
    event.preventDefault()
    const clone = this.completionTaskTemplateTarget.content.cloneNode(true)
    this.completionTasksTarget.appendChild(clone)
  }

  removeCompletionRow(event) {
    const btn = event.target.closest(".remove-completion-task")
    if (!btn) return
    event.preventDefault()
    btn.closest(".completion-task-row").remove()
  }
}
